module.exports = __webpack_public_path__ + "img/q2a1.56f7abb4.png";